import { ReactElement } from "react";
import { Spinner } from "@justworkshr/milo-core";

import styles from "./page-loading.module.css";

const PageLoading = (): ReactElement => {
  return (
    <div className={styles.pageLoading}>
      <Spinner />
    </div>
  );
};

export default PageLoading;
